import { ButtonBase, Skeleton, type ButtonBaseProps } from "@mui/material";

export type Props = Pick<ButtonBaseProps, "onClick" | "children"> & {
  fullWidth?: boolean;
  borderRadius?: string;
  active?: boolean;
};

export function FilterButton({
  onClick,
  children,
  fullWidth,
  active,
  borderRadius = "var(--radius-xl)",
}: Props) {
  return (
    <ButtonBase
      onClick={onClick}
      className="shrink-0 text-sm shadow-xs"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "calc(var(--spacing)*2)",
        borderRadius,
        backgroundColor: active
          ? "var(--color-surface-accent-softer)"
          : "var(--color-white)",
        border: active ? "1px solid" : "none",
        borderColor: active ? "var(--color-surface-accent-medium)" : "inherit",
        paddingInline: "calc(var(--spacing)*3)",
        paddingBlock: "calc(var(--spacing)*2)",
        textAlign: "start",
        color: "var(--color-text-primary)",
        width: fullWidth ? "100%" : "auto",
        overflow: "hidden",
      }}
    >
      {children}
    </ButtonBase>
  );
}

export const FilterButtonSkeleton = () => (
  <div className="flex items-center justify-center rounded-xl bg-white px-3 py-2">
    <Skeleton width={86} height={20} />
  </div>
);
